import WorkExperience from './WorkExperience.container';

export default WorkExperience;
